import React, { useCallback, useEffect, useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
} from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useLocalStorage from 'react-localstorage-hook';
import { WidgetIncomingEvent } from '@getvim/vim-connect-app';
import { isEmpty } from 'lodash-es';
import { DisplayError } from '../../mocks/vim-connect-ui-events';
import { FlexBox } from '../common/FlexBox';
import { MonacoEditor } from '../monaco-editor';
import { handlePublish } from './utils';

export const DisplayErrorTab = () => {
  const [payload, setPayload] = useState<string>();
  const [predefinedPayload, setPredefinedPayload] = useState<string>('');
  const [lastUsedPayload, setLastUsedPayload] = useLocalStorage('lastDisplayErrorPayload', '');

  const handlePredefinedPayloadChange = useCallback(
    ({ target: { value } }: SelectChangeEvent) => {
      setPredefinedPayload(value);
      setLastUsedPayload(value);
      setPayload(DisplayError.predefinedPayloads[value]);
    },
    [setLastUsedPayload],
  );

  useEffect(() => {
    handlePredefinedPayloadChange({ target: { value: lastUsedPayload } } as SelectChangeEvent);
  }, [handlePredefinedPayloadChange, lastUsedPayload]);

  return (
    <Accordion id="displayErrorTab">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>DisplayError</Typography>
        <Select
          displayEmpty
          value={predefinedPayload}
          id="select-display-error"
          size="small"
          onChange={handlePredefinedPayloadChange}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <MenuItem value="">Choose</MenuItem>
          {Object.keys(DisplayError.predefinedPayloads).map((value, index) => (
            <MenuItem id={`select-display-error-${index}`} value={value} key={value}>
              {value}
            </MenuItem>
          ))}
        </Select>

        <Button
          id="publish-display-error"
          disabled={isEmpty(predefinedPayload)}
          fullWidth
          onClick={(e) => {
            e.stopPropagation();
            handlePublish(payload, WidgetIncomingEvent.DisplayError);
          }}
          variant="contained"
        >
          Publish
        </Button>
      </AccordionSummary>
      <AccordionDetails>
        <MonacoEditor onChange={setPayload} height="20rem" value={payload} />

        <FlexBox>
          <TextField
            id="displayErrorPayload"
            variant="outlined"
            size="small"
            value={JSON.stringify(payload)}
            sx={{ display: 'none' }}
          />
        </FlexBox>
      </AccordionDetails>
    </Accordion>
  );
};
